var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g3, _path25, _g4, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g5, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g6, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g7, _path50, _g8, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g9, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g10, _path67, _g11, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g12, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g13, _path84, _g14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9235 0H2.1059V15.9982H11.9235V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9235 0H2.1059V16H11.9235V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.012 15.9985C9.72132 15.9985 11.9177 12.4171 11.9177 7.99926C11.9177 3.58139 9.72132 0 7.012 0C4.30267 0 2.10632 3.58139 2.10632 7.99926C2.10632 12.4171 4.30267 15.9985 7.012 15.9985Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9235 0H2.1059V16H11.9235V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9176 7.99926C11.9176 12.4172 9.72139 15.9985 7.01193 15.9985C4.30248 15.9985 2.1059 12.4168 2.1059 7.99926C2.1059 3.58168 4.30248 0 7.01193 0C9.72139 0 11.9176 3.58131 11.9176 7.99926Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9172 0H2.1059V15.9982H11.9172V0Z",
    fill: "#9B9B9B"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5096 0.389648H2.5061V15.5604H11.5096V0.389648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5096 0.389648H2.5061V15.5604H11.5096V0.389648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01005 15.5578C9.49367 15.5578 11.507 12.1623 11.507 7.97372C11.507 3.78515 9.49367 0.389648 7.01005 0.389648C4.52643 0.389648 2.51306 3.78515 2.51306 7.97372C2.51306 12.1623 4.52643 15.5578 7.01005 15.5578Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5096 0.389648H2.5061V15.5604H11.5096V0.389648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 10,
    height: 16
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.507 7.97372C11.507 12.1625 9.49359 15.5578 7.01005 15.5578C4.52651 15.5578 2.51306 12.1621 2.51306 7.97372C2.51306 3.78532 4.52651 0.389648 7.01005 0.389648C9.49359 0.389648 11.507 3.78532 11.507 7.97372Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.507 0.389648H2.51306V15.5578H11.507V0.389648Z",
    fill: "url(#paint0_linear_2868_44873)"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 8,
    height: 15
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9762 0.914062H3.04639V14.6041H10.9762V0.914062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 8,
    height: 15
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9762 0.914062H3.04639V14.6041H10.9762V0.914062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 8,
    height: 15
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01187 14.6038C9.19953 14.6038 10.973 11.5399 10.973 7.76037C10.973 3.98088 9.19953 0.916992 7.01187 0.916992C4.82422 0.916992 3.05078 3.98088 3.05078 7.76037C3.05078 11.5399 4.82422 14.6038 7.01187 14.6038Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 8,
    height: 15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9762 0.914062H3.04639V14.6041H10.9762V0.914062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 8,
    height: 15
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9726 7.76049C10.9726 11.54 9.19932 14.6039 7.01151 14.6039C4.82369 14.6039 3.05042 11.54 3.05042 7.76049C3.05042 3.981 4.82406 0.91748 7.01187 0.91748C9.19969 0.91748 10.973 3.98137 10.973 7.76086",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9729 0.91748H3.05109V14.6042H10.9729V0.91748Z",
    fill: "url(#paint1_linear_2868_44873)"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 10,
    height: 9
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9234 7.75879H2.10583V15.9979H11.9234V7.75879Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7103 7.76074C11.5978 7.76074 11.5067 7.85337 11.5071 7.96704V7.97406C11.5071 12.1628 9.49365 15.5581 7.01011 15.5581C4.52656 15.5581 2.51312 12.1625 2.51312 7.97406V7.96704C2.51312 7.85337 2.42246 7.76074 2.30987 7.76074C2.19728 7.76074 2.10663 7.85227 2.10626 7.96557C2.10626 7.97664 2.10626 7.98808 2.10626 7.99915C2.10626 12.4171 4.30248 15.9984 7.01193 15.9984C9.72139 15.9984 11.9176 12.4171 11.9176 7.99915C11.9176 7.98771 11.9176 7.97664 11.9176 7.96557C11.9176 7.85227 11.8262 7.76074 11.714 7.76074H11.7103Z",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 11,
    height: 16
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1586 0H13.341V15.9982H23.1586V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 11,
    height: 16
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1586 0H13.341V16H23.1586V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 11,
    height: 16
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2525 15.9985C20.9619 15.9985 23.1582 12.4171 23.1582 7.99926C23.1582 3.58139 20.9619 0 18.2525 0C15.5432 0 13.3469 3.58139 13.3469 7.99926C13.3469 12.4171 15.5432 15.9985 18.2525 15.9985Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 11,
    height: 16
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1586 0H13.341V16H23.1586V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 11,
    height: 16
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1582 7.99926C23.1582 12.4172 20.962 15.9985 18.2525 15.9985C15.5431 15.9985 13.3469 12.4172 13.3469 7.99926C13.3469 3.58131 15.5431 0 18.2525 0C20.962 0 23.1582 3.58131 23.1582 7.99926Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1582 0H13.3469V15.9982H23.1582V0Z",
    fill: "#9B9B9B"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 10,
    height: 16
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7513 0.389648H13.7479V15.5604H22.7513V0.389648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 10,
    height: 16
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7513 0.389648H13.7479V15.5604H22.7513V0.389648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 10,
    height: 16
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 7.97372C22.7477 12.1625 20.7343 15.5578 18.2507 15.5578C15.7672 15.5578 13.7537 12.1621 13.7537 7.97372C13.7537 3.78532 15.7672 0.389648 18.2507 0.389648C20.7343 0.389648 22.7477 3.78532 22.7477 7.97372Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 10,
    height: 16
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7513 0.389648H13.7479V15.5604H22.7513V0.389648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 10,
    height: 16
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 7.97372C22.7477 12.1625 20.7343 15.5578 18.2507 15.5578C15.7672 15.5578 13.7537 12.1621 13.7537 7.97372C13.7537 3.78532 15.7672 0.389648 18.2507 0.389648C20.7343 0.389648 22.7477 3.78532 22.7477 7.97372Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 0.389648H13.7537V15.5578H22.7477V0.389648Z",
    fill: "url(#paint2_linear_2868_44873)"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 9,
    height: 15
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.218 0.914062H14.2881V14.6041H22.218V0.914062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 9,
    height: 15
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M22.218 0.914062H14.2881V14.6041H22.218V0.914062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 9,
    height: 15
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2525 14.6038C20.4402 14.6038 22.2136 11.5399 22.2136 7.76037C22.2136 3.98088 20.4402 0.916992 18.2525 0.916992C16.0649 0.916992 14.2914 3.98088 14.2914 7.76037C14.2914 11.5399 16.0649 14.6038 18.2525 14.6038Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 9,
    height: 15
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.218 0.914062H14.2881V14.6041H22.218V0.914062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask48_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 9,
    height: 15
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2136 7.76049C22.2136 11.54 20.4403 14.6039 18.2525 14.6039C16.0647 14.6039 14.2914 11.54 14.2914 7.76049C14.2914 3.981 16.0651 0.91748 18.2525 0.91748C20.44 0.91748 22.2136 3.98137 22.2136 7.76086",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2139 0.91748H14.2921V14.6042H22.2139V0.91748Z",
    fill: "url(#paint3_linear_2868_44873)"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 7,
    width: 11,
    height: 9
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1586 7.75879H13.341V15.9979H23.1586V7.75879Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9513 7.76025C22.8387 7.76025 22.7477 7.85289 22.7481 7.96656V7.97357C22.7481 12.1623 20.7346 15.5576 18.2511 15.5576C15.7675 15.5576 13.7541 12.162 13.7541 7.97357V7.96656C13.7541 7.85289 13.6634 7.76025 13.5508 7.76025C13.4383 7.76025 13.3476 7.85178 13.3472 7.96508C13.3472 7.97615 13.3472 7.98759 13.3472 7.99866C13.3472 12.4166 15.5434 15.9979 18.2529 15.9979C20.9624 15.9979 23.1586 12.4166 23.1586 7.99866C23.1586 7.98722 23.1586 7.97615 23.1586 7.96508C23.1586 7.85178 23.0672 7.76025 22.955 7.76025H22.9513Z",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask52_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95169 6.00879H2.5061V11.5073H7.95169V6.00879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask54_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95169 6.00879H2.5061V11.5073H7.95169V6.00879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94695 8.75722C7.94695 10.2726 6.7304 11.5008 5.22982 11.5008C3.72924 11.5008 2.5127 10.2726 2.5127 8.75722C2.5127 7.24189 3.72924 6.01367 5.22982 6.01367C6.7304 6.01367 7.94695 7.24189 7.94695 8.75722Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask56_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95169 6.00879H2.5061V11.5073H7.95169V6.00879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94695 8.75722C7.94695 10.2726 6.7304 11.5008 5.22982 11.5008C3.72924 11.5008 2.5127 10.2726 2.5127 8.75722C2.5127 7.24189 3.72924 6.01367 5.22982 6.01367C6.7304 6.01367 7.94695 7.24189 7.94695 8.75722Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.87152 3.6394L0.159546 10.1304L6.58823 13.8776L10.3002 7.38659L3.87152 3.6394Z",
    fill: "url(#paint4_linear_2868_44873)"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask60_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74115 6.22168H2.71667V11.2951H7.74115V6.22168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask62_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74115 6.22168H2.71667V11.2951H7.74115V6.22168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7375 8.75767C7.7375 10.156 6.6149 11.2898 5.22984 11.2898C3.84477 11.2898 2.72217 10.156 2.72217 8.75767C2.72217 7.35932 3.84477 6.22559 5.22984 6.22559C6.6149 6.22559 7.7375 7.35932 7.7375 8.75767Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask64_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74115 6.22168H2.71667V11.2951H7.74115V6.22168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 6,
    width: 6,
    height: 6
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7375 8.75767C7.7375 10.156 6.6149 11.2898 5.22984 11.2898C3.84477 11.2898 2.72217 10.156 2.72217 8.75767C2.72217 7.35932 3.84477 6.22559 5.22984 6.22559C6.6149 6.22559 7.7375 7.35932 7.7375 8.75767Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.97628 4.03395L0.550537 10.0244L6.48379 13.4828L9.90953 7.49236L3.97628 4.03395Z",
    fill: "url(#paint5_linear_2868_44873)"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9055 8.75718C6.9055 9.69162 6.15539 10.4489 5.22982 10.4489C4.30425 10.4489 3.55414 9.69162 3.55414 8.75718C3.55414 7.82273 4.30425 7.06543 5.22982 7.06543C6.15539 7.06543 6.9055 7.82273 6.9055 8.75718Z",
    fill: "#200302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93586 9.97668L6.92087 9.96414C6.76112 9.83238 6.53083 9.84382 6.38095 9.98702C6.08084 10.2738 5.67581 10.4494 5.22984 10.4494C5.11103 10.4494 4.99516 10.4369 4.88366 10.4133C4.69577 10.3734 4.50495 10.4686 4.42636 10.6454L4.41795 10.6639C4.31194 10.9012 4.44866 11.1783 4.70089 11.2329C4.8716 11.2699 5.04853 11.2894 5.2302 11.2894C5.90026 11.2894 6.50926 11.0237 6.95889 10.5912C7.13581 10.421 7.12521 10.1324 6.93622 9.97632",
    fill: "#E5AD30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22981 7.29433C5.22981 7.70693 4.89862 8.0413 4.4903 8.0413C4.08198 8.0413 3.75079 7.70693 3.75079 7.29433C3.75079 6.88173 4.08198 6.54736 4.4903 6.54736C4.89862 6.54736 5.22981 6.88173 5.22981 7.29433Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask68_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask69_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask70_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 7,
    height: 6
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1935 6.00879H13.7479V11.5073H19.1935V6.00879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 7,
    height: 6
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1935 6.00879H13.7479V11.5073H19.1935V6.00879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask72_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 7,
    height: 6
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19.188 8.75722C19.188 10.2726 17.9714 11.5008 16.4709 11.5008C14.9703 11.5008 13.7537 10.2726 13.7537 8.75722C13.7537 7.24189 14.9703 6.01367 16.4709 6.01367C17.9714 6.01367 19.188 7.24189 19.188 8.75722Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 7,
    height: 6
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1935 6.00879H13.7479V11.5073H19.1935V6.00879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask74_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 7,
    height: 6
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M19.188 8.75722C19.188 10.2726 17.9714 11.5008 16.4709 11.5008C14.9703 11.5008 13.7537 10.2726 13.7537 8.75722C13.7537 7.24189 14.9703 6.01367 16.4709 6.01367C17.9714 6.01367 19.188 7.24189 19.188 8.75722Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1135 3.6394L11.4015 10.1304L17.8302 13.8776L21.5421 7.38659L15.1135 3.6394Z",
    fill: "url(#paint6_linear_2868_44873)"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask76_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask77_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask78_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 6,
    height: 6
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9828 6.22168H13.9584V11.2951H18.9828V6.22168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 6,
    height: 6
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9828 6.22168H13.9584V11.2951H18.9828V6.22168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask80_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 6,
    height: 6
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9785 8.75767C18.9785 10.156 17.8559 11.2898 16.4708 11.2898C15.0857 11.2898 13.9631 10.156 13.9631 8.75767C13.9631 7.35932 15.0857 6.22559 16.4708 6.22559C17.8559 6.22559 18.9785 7.35932 18.9785 8.75767Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask81_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 6,
    height: 6
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9828 6.22168H13.9584V11.2951H18.9828V6.22168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_2868_44873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask82_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 6,
    width: 6,
    height: 6
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9785 8.75767C18.9785 10.156 17.8559 11.2898 16.4708 11.2898C15.0857 11.2898 13.9631 10.156 13.9631 8.75767C13.9631 7.35932 15.0857 6.22559 16.4708 6.22559C17.8559 6.22559 18.9785 7.35932 18.9785 8.75767Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.218 4.03444L11.7922 10.0249L17.7255 13.4833L21.1512 7.49285L15.218 4.03444Z",
    fill: "url(#paint7_linear_2868_44873)"
  })))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_2868_44873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 22,
    height: 16
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M23.16 0H2.10437V15.9985H23.16V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_2868_44873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1462 8.75718C18.1462 9.69162 17.3961 10.4489 16.4708 10.4489C15.5456 10.4489 14.7955 9.69162 14.7955 8.75718C14.7955 7.82273 15.5456 7.06543 16.4708 7.06543C17.3961 7.06543 18.1462 7.82273 18.1462 8.75718Z",
    fill: "#200302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1769 9.97668L18.1619 9.96414C18.0022 9.83238 17.7719 9.84382 17.622 9.98702C17.3219 10.2738 16.9168 10.4494 16.4709 10.4494C16.3521 10.4494 16.2362 10.4369 16.1247 10.4133C15.9364 10.3734 15.746 10.4686 15.6674 10.6454L15.6593 10.6639C15.5533 10.9012 15.6901 11.1783 15.9423 11.2329C16.113 11.2699 16.2899 11.2894 16.4712 11.2894C17.1413 11.2894 17.7503 11.0237 18.1999 10.5912C18.3768 10.421 18.3662 10.1324 18.1773 9.97632",
    fill: "#E5AD30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4708 7.29433C16.4708 7.70693 16.1396 8.0413 15.7313 8.0413C15.323 8.0413 14.9918 7.70693 14.9918 7.29433C14.9918 6.88173 15.323 6.54736 15.7313 6.54736C16.1396 6.54736 16.4708 6.88173 16.4708 7.29433Z",
    fill: "#F4F4F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2868_44873",
    x1: 6.78165,
    y1: 15.4762,
    x2: 6.78165,
    y2: 0.308088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2868_44873",
    x1: 6.74533,
    y1: 14.7101,
    x2: 6.74533,
    y2: 1.0233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2868_44873",
    x1: 18.0223,
    y1: 15.4762,
    x2: 18.0223,
    y2: 0.308088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2868_44873",
    x1: 17.986,
    y1: 14.7101,
    x2: 17.986,
    y2: 1.0233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2868_44873",
    x1: 3.37028,
    y1: 7.28814,
    x2: 9.80134,
    y2: 10.9673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F1C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4F1C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#501D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#511E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#532002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#542102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#562202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#572302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#582502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5A2603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#5B2703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5C2903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#5D2A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5F2B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#602C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#612E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#632F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#643004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#663104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#673205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#683405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#693505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6B3605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6C3806"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6D3906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6E3A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#703B06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#713C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#733E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#743F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#754007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#774207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#784307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#794408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7A4508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7C4708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7E4908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#804A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#814B09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#834D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#844E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#854F09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#86500A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#88520A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#89530A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8A540A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#8C560A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8D570B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8F580B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#905A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#915B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#925C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#945D0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#955F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#96600C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#98610C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99620C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9A640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9C650D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9D660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9F670D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A0680D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A16A0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#A26B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A46C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A56D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A66F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A7700F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A9710F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AA730F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AB740F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#AD7510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#AF7710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AF7710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B07810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B07810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2868_44873",
    x1: 3.32748,
    y1: 7.72386,
    x2: 9.26286,
    y2: 11.1195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#582A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#582A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#582A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#5A2B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5B2D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5D2E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5E2F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#603101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#613202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#633402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#653502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#673603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#683803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#6A3903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C3B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#6D3C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6F3D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#713F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#724005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#744205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#754305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#774405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#784506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7A4706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7C4906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7E4A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7F4B07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#814C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#824D07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#844F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#865108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#875208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#895309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8A5409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8C5609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8E5709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#90590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#915A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#935B0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#955D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#965E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#98600B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9A610C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9B620C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9C640C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9E650C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#A0670D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A1680D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3690D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A56B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A76C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#A86E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AA6F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AB700F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#AD720F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#AF730F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B0740F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B27610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B37710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B57910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B77A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B87B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BA7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BC7E11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BE8012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#BF8112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C18212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C28313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C48513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C58613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C78813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C98914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CA8A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CC8C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CE8E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#CF8F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D08F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D08F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D08F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2868_44873",
    x1: 14.6114,
    y1: 7.28891,
    x2: 21.0424,
    y2: 10.9681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F1C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4F1C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#501D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#511E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#532002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#542102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#562202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#572302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#582502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5A2603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#5B2703"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5C2903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#5D2A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5F2B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#602C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#612E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#632F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#643004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#663104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#673205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#683405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#693505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6B3605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6C3806"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6D3906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6E3A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#703B06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#713C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#733E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#743F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#754007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#774207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#784307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#794408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7A4508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7C4708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7E4908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#804A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#814B09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#834D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#844E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#854F09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#86500A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#88520A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#89530A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8A540A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#8C560A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8D570B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8F580B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#905A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#915B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#925C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#945D0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#955F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#96600C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#98610C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99620C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9A640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#9C650D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9D660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9F670D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A0680D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A16A0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#A26B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#A46C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A56D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A66F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A7700F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A9710F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AA730F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#AB740F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#AD7510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#AF7710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#AF7710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B07810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B07810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2868_44873",
    x1: 14.5692,
    y1: 7.72435,
    x2: 20.5046,
    y2: 11.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#582A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#582A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#582A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#5A2B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5B2D01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5D2E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5E2F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#603101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#613202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#633402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#653502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#673603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#683803"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#6A3903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C3B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#6D3C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6F3D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#713F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#724005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#744205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#754305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#774405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#784506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7A4706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7C4906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7E4A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7F4B07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#814C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#824D07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#844F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#865108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#875208"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#895309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8A5409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8C5609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8E5709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#90590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#915A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#935B0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#955D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#965E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#98600B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9A610C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9B620C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9C640C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9E650C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#A0670D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A1680D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3690D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A56B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A76C0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#A86E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AA6F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AB700F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#AD720F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#AF730F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B0740F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B27610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B37710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B57910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B77A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B87B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BA7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#BC7E11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BE8012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#BF8112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C18212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C28313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C48513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C58613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#C78813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C98914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#CA8A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CC8C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CE8E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#CF8F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D08F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D08F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D08F15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2868_44873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    fill: "white",
    transform: "translate(0.160034)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.b9c82f12b43c6650de728d280ddbe621.svg";
export { ForwardRef as ReactComponent };